import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
// import { Link } from '@bd/bdcore-named-routes';

const styles = css`
.agentsTitle {
  font-weight:700;
}
  .agentsList {
    a {
      text-decoration:underline;
      white-space:nowrap;
    }
    span {
      white-space:nowrap;
    }
  }
`;

function AgentsList({ agents }) {
  return (
    <div className={styles}>
      {
        agents.length > 0 &&
        <div>
          <h5 className="agentsTitle">Agents</h5>
          <ul className="list-unstyled agentsList">
            {
              agents.map(item => (
                <li key={item._id}>
                  <strong>
                    {item.name}
                  </strong>:
                  <span> {item.email}</span>
                  <a href={`tel:${get(item, 'telephone').replace(/[^0-9]/g, '')}`}> {get(item, 'telephone').replace(/\((\d{3})\)\s(\d{3})\s-\s(\d{4})/g, '$1-$2-$3')}</a>
                </li>
              ))
            }
          </ul>
        </div>
      }
    </div>
  );
}

AgentsList.propTypes = {
  // community: PropTypes.object.isRequired,
  agents: PropTypes.arrayOf(PropTypes.object),
};

AgentsList.defaultProps = {
  agents: undefined,
};

export default withData(
  {
    community: true,
    agents: true,
  },
  {
    required: {
      community: true,
    },
  },
)(AgentsList);



// WEBPACK FOOTER //
// ./src/components/AgentsList.js